import React from 'react'
import Loading from '@albatross/common-components/dist/components/Loading'
import { venture, enableContentful } from '../../../config'

const LoadingPage = () => <Loading venture={venture} enableContentful={enableContentful} />

export default LoadingPage
